/**
 * Normalising a battery serial number.
 *
 * Its own file, with no DOM references, because two things need it: the
 * screens (which are full of DOM) and the root test runner (which has none).
 * Keeping it separate from barcode.ts means testing the rule does not drag a
 * camera pipeline and a wasm loader into the type program.
 */

/**
 * The one spelling a serial is stored and compared as.
 *
 * Upper-cased, trimmed, inner whitespace collapsed - so "tx 4471a" typed by
 * one agent and "TX  4471A" scanned by another are the same battery.
 *
 * Hyphens and slashes are deliberately NOT stripped: on a battery label they
 * are frequently part of the number, and removing them would silently merge
 * two different batteries into one record. Idempotent, so re-normalising a
 * stored value changes nothing.
 */
export function normaliseSerial(raw: string): string {
  return raw.trim().replace(/\s+/g, " ").toUpperCase();
}
